// src/utils/formUtils.js
export const normalizeInitialValues = (file, { keepName = false } = {}) => {
  const normalize = (v) =>
    v === undefined || v === null ? null : typeof v === "object" && "id" in v ? v.id : v;

  const { id, created_at, updated_at, deleted_at, created_by, deleted_by, updated_by, ...rest } =
    file || {};

  const normalized = {
    ...rest,
    beam_isotope: normalize(file?.beam_isotope),
    detector: normalize(file?.detector),
    reaction: normalize(file?.reaction),
    energy_detector: normalize(file?.energy_detector),
    TOF_detector: normalize(file?.TOF_detector),
    created_by: normalize(file?.created_by),
    updated_by: normalize(file?.updated_by),
    deleted_by: normalize(file?.deleted_by),
    proposal: normalize(file?.proposal),
    id: normalize(file?.id),
  };

  if (!keepName) {
    normalized.name = "";
  }

  return normalized;
};
